/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useContext, useEffect } from "react";
import { useLocation, Route, Routes, Navigate, useNavigate } from "react-router-dom";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import logoClaro from 'assets/img/brand/logo-estreito-claro.png'
import logoEscuro from 'assets/img/brand/logo-estreito-escuro.png'

import routes from "routes.js";
import AppContext from "AppContext";
import AvisoSemContrato, { papelSemContrato } from "components/AvisoSemContrato";
import { Container } from "reactstrap";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { state, actions } = useContext(AppContext)
  const navigate = useNavigate()

  const acoesUsuario = state?.user?.acoes || []

  useEffect(() => {
    if (state.user) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  useEffect(() => {
    actions.checkToken().then(logged => {
      if (!logged) {
        navigate("/auth/login", { replace: true })
      }
    })
  }, [])

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes.filter(el => el.showMenu && el.acoes.some(ac => acoesUsuario.includes(ac)))}
        logo={{
          innerLink: "/admin/index",
          imgSrc: state.theme === 'dark' ? logoEscuro : logoClaro,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <div className="header bg-gradient-info" style={{ height: 80 }}>
        </div>
        {papelSemContrato(state) && (
          <Container fluid className="mt-4">
            <AvisoSemContrato state={state} />
          </Container>
        )}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
        {/* <Container fluid>
          <AdminFooter />
        </Container> */}
      </div>
    </>
  );
};

export default Admin;
